import script from "./ProductCardLens.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCardLens.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__